<template>
  <div>
    <b-row>
      <b-col>
        <h4>ポイント一覧</h4>
      </b-col>
    </b-row>
    <b-row class="component-margin-half">
      <b-col>
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
            :items="slcAnalysisItems" :fields="fields"
            :current-page="currentPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="inboundQuantityToday1" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday1']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal1']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount1']}})</label></div>
          </template>
          <template slot="inboundQuantityToday2" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday2']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal2']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount2']}})</label></div>
          </template>
          <template slot="inboundQuantityToday3" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday3']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal3']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount3']}})</label></div>
          </template>
          <template slot="inboundQuantityToday4" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday4']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal4']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount4']}})</label></div>
          </template>
          <template slot="inboundQuantityToday5" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday5']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal5']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount5']}})</label></div>
          </template>
          <template slot="inboundQuantityToday6" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday6']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal6']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount6']}})</label></div>
          </template>
          <template slot="inboundQuantityToday7" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday7']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal7']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount7']}})</label></div>
          </template>
          <template slot="inboundQuantityToday8" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday8']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal8']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount8']}})</label></div>
          </template>
          <template slot="inboundQuantityToday9" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday9']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal9']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount9']}})</label></div>
          </template>
          <template slot="inboundQuantityToday10" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday10']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal10']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount10']}})</label></div>
          </template>
          <template slot="inboundQuantityToday11" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday11']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal11']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount11']}})</label></div>
          </template>
          <template slot="inboundQuantityToday12" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday12']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal12']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount12']}})</label></div>
          </template>
          <template slot="inboundQuantityToday13" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday13']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal13']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount13']}})</label></div>
          </template>
          <template slot="inboundQuantityToday14" slot-scope="row">
            <div><label>{{row.item['inboundQuantityToday14']}}</label></div>
            <div><label>(累計：{{row.item['inboundQuantityTotal14']}})</label></div>
            <div><label>(セラー数：{{row.item['memberCount14']}})</label></div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';

export default {
  mixins: [BaseComponent],
  props: {
    slcAnalysisItems: {
      default: [],
    }
  },
  data() {
    return {
      fields: [
        { key: 'inboundQuantityToday1', label: '麻耶', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday2', label: '麻衣', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday3', label: '橋本', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday4', label: '小宮', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday5', label: '中村', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday6', label: '増山', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday7', label: '門谷', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday8', label: '山中', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday9', label: '上村', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday10', label: '平山', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday11', label: '又平', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday12', label: '秀徳', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday13', label: '湯野', sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'inboundQuantityToday14', label: '秋山', sortable: true, variant: 'base', class: 'table-cw3' },
      ],
      currentPage: 1,
      perPage: 100,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      activate: false,
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style>
.component-margin-half {
  margin-bottom: .5rem;
}
.image {
  align-content: center;
}
table > thead > tr > th {
  text-align: center!important;
}
th.table-base {
  background-color: aliceblue!important;
}
/* th.table-warning {
  background-color: gray;
} */
td.table-success{
  background-color: rgba(40,167,69,.25);
}
td.table-warning{
  background-color: #ffeeba59;
}
table label{
  margin-bottom: 0;
}
table .image{
  height: 3rem;
  width: 3rem;
}
.pr0{
  padding-right: 0;
}
.pl0{
  padding-left: 0;
}
.btn-100{
  height: 100%;
}
.pw05{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.matome-status-mark .custom-control-input:disabled:checked~.custom-control-label:before {
    background-color: #ff0000cf;
}
@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>

